import { render, staticRenderFns } from "./ViewPushnotesPage.vue?vue&type=template&id=0719ee0f&scoped=true&"
import script from "./ViewPushnotesPage.vue?vue&type=script&lang=js&"
export * from "./ViewPushnotesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0719ee0f",
  null
  
)

export default component.exports